namespace RedBullMOBILE360.SpecialEvent {
    export interface SpecialEventRow {
        Id?: number;
        EventName?: string;
        ImageUrl?: string;
        UploadDate?: string;
    }

    export namespace SpecialEventRow {
        export const idProperty = 'Id';
        export const nameProperty = 'EventName';
        export const localTextPrefix = 'SpecialEvent.SpecialEvent';
        export const deletePermission = 'SpecialEvent:Generate';
        export const insertPermission = 'SpecialEvent:Generate';
        export const readPermission = 'SpecialEvent:Generate';
        export const updatePermission = 'SpecialEvent:Generate';

        export declare const enum Fields {
            Id = "Id",
            EventName = "EventName",
            ImageUrl = "ImageUrl",
            UploadDate = "UploadDate"
        }
    }
}
